/* Page cross-fade between the three primary sections — Work, About, Contact.

   Every other navigation on this site already has motion of its own: a work row
   flies into its case study, the case study flies back, a language switch
   cross-fades. Clicking "About" was the one that hard-cut. This is the other
   half of the CSS in "Page cross-fade" in screen.css: fade the body and footer
   out, leave a note, navigate, and let the arriving document fade its own body
   in from the pre-paint gate in default.hbs.

   The navigation bar is deliberately untouched — see the CSS comment.

   Every guard below is a way of letting the anchor just be an anchor: a
   middle-click or a modified click still opens a tab, reduced motion still
   navigates flat, and with no JavaScript at all none of this exists. Same
   contract the locale switcher and the work arrow keep. */

var MIKA_PAGE_TRANSITION_KEY = 'mk-page-transition';

/* The primary section links, in both the desktop and the mobile menu, minus:

   - the EN | DE control, which is locale.js's — it writes its own note and runs
     its own fade, and two of these racing would leave whichever lost holding a
     stale class over a page that had already gone;
   - the link to the page you are already on, which changes nothing and so has
     nothing to cross-fade;
   - the back arrow on a case study, which is work-closing.js's flight and is a
     sibling of this list rather than inside it.

   The wordmark is in, because it is a real navigation back to Work and reads as
   a dead hard cut beside the menu item that goes to the same place. */
function pageTransitionLinks() {
    return Array.prototype.slice.call(document.querySelectorAll(
        '.gh-localized-links > li:not(.gh-locale-control) > a:not([aria-current="page"]),' +
        '.gh-profile-nav a:not([aria-current="page"]),' +
        '.gh-navigation-logo'
    ));
}

function pageCssMs(name, fallback) {
    var declared = parseInt(
        window.getComputedStyle(document.documentElement).getPropertyValue(name),
        10
    );

    return isNaN(declared) ? fallback : declared;
}

function pageFadeOutMs() {
    return pageCssMs('--page-fade-out-ms', 180);
}

// The fold-up runs on work-closing.js's clock, not this file's.
function workClosingMs() {
    return pageCssMs('--work-closing-duration-ms', 320);
}

/* True when the subnavigation is on both sides of this navigation, and so should
   hold still through it rather than fade with the body — see the CSS comment.
   The nav only exists on the three profile pages, so its presence answers for
   the page being left, and one of its own hrefs answers for the page being
   opened. Asking the nav rather than matching paths here means the main menu's
   About link counts too: it lands on a page carrying the same subnavigation, so
   it is the same swap by any name. */
function pageIsProfileSwap(href) {
    var nav = document.querySelector('.gh-profile-nav');

    return !!nav && Array.prototype.some.call(
        nav.querySelectorAll('a'),
        function (link) {
            return link.href === href;
        }
    );
}

function pageTransition() {
    var links = pageTransitionLinks();
    if (!links.length) return;

    var leaving = false;

    links.forEach(function (link) {
        link.addEventListener('click', function (event) {
            if (event.defaultPrevented || event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            if (leaving) return;

            event.preventDefault();
            leaving = true;

            var swap = pageIsProfileSwap(link.href);

            /* The note the arriving document reads pre-paint to fade itself in.
               Without it the new page simply arrives at full opacity, which is
               the old behaviour, not a broken one. It carries which of the two
               fades to run, because only this side can tell. */
            try {
                sessionStorage.setItem(MIKA_PAGE_TRANSITION_KEY, swap ? 'profile' : '1');
            } catch (e) {
                // Private mode; the transition loses its second half, nothing else.
            }

            /* An open case study closes before it leaves, rather than fading out
               as a page. It is a thing that was opened, so it should be seen to
               shut — and work-closing.js already owns that motion, including the
               branch for closing toward somewhere that is not the overview.

               The arriving page still fades in either way: the note above is
               already written, and this only changes what the reader watches on
               the way out, and for how long. */
            // One timer off the declared duration keeps CSS and JS honest,
            // rather than listening for one of two animationends.
            var navigateIn = function (ms) {
                window.setTimeout(function () {
                    window.location.href = link.href;
                }, ms + 20);
            };

            /* The fold calls back when it actually starts, because a case study
               scrolled down rides back to the top first — the clock has to start
               at the fold, not at the click, or the navigation lands mid-scroll. */
            var folding = typeof window.mikaWorkFoldUp === 'function'
                && window.mikaWorkFoldUp(function () {
                    navigateIn(workClosingMs());
                });

            if (!folding) {
                /* Toggled rather than added, and here rather than beside the
                   note, because the page this click leaves may itself have
                   arrived through a swap — the entering half's class is never
                   taken off — and an ordinary navigation out of it would
                   otherwise find the flag still set and fade a panel the next
                   page has not got. A folding case study carries no
                   subnavigation on either side, so it never asks. */
                document.documentElement.classList.toggle('is-profile-swap', swap);
                document.documentElement.classList.add('is-page-leaving');
                navigateIn(pageFadeOutMs());
            }
        });
    });

    /* Coming back to a faded-out page from the bfcache would otherwise restore
       it mid-fade and leave it there — the leaving animation fills forwards. */
    window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;

        leaving = false;
        document.documentElement.classList.remove('is-page-leaving');
        document.documentElement.classList.remove('is-profile-swap');
    });
}
